import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-white">
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Logo invert size="xl" />
          <p className="mt-8 text-white/75 max-w-md leading-relaxed text-[15px]">
            Agence digitale dans le Tarn. Nous accompagnons les PME, artisans
            et créateurs d’entreprise de Marssac-sur-Tarn, Albi, Gaillac,
            Castres et Carmaux pour construire une présence en ligne durable.
          </p>
          <div className="mt-10 flex flex-col gap-3 text-sm">
            <a href="tel:+33646792554" data-testid="footer-phone" className="inline-flex items-center gap-3 text-white/85 hover:text-white">
              <Phone size={16} className="opacity-60" /> 06 46 79 25 54
            </a>
            <a href="mailto:contact.agency.webup@gmail.com" data-testid="footer-email" className="inline-flex items-center gap-3 text-white/85 hover:text-white break-all">
              <Mail size={16} className="opacity-60" /> contact.agency.webup@gmail.com
            </a>
            <div className="inline-flex items-center gap-3 text-white/85">
              <MapPin size={16} className="opacity-60" /> Marssac-sur-Tarn — Tarn (81)
            </div>
            <a href="https://webup-tarn.fr" target="_blank" rel="noreferrer" className="inline-flex items-center gap-3 text-white/85 hover:text-white">
              <ArrowUpRight size={16} className="opacity-60" /> webup-tarn.fr
            </a>
          </div>
        </div>

        <div className="md:col-span-3 md:col-start-7">
          <p className="font-mono-label text-white/55">Navigation</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li><a href="#services" className="text-white/80 hover:text-white">Services</a></li>
            <li><a href="#processus" className="text-white/80 hover:text-white">Notre processus</a></li>
            <li><a href="#tarifs" className="text-white/80 hover:text-white">Tarifs</a></li>
            <li><a href="#realisations" className="text-white/80 hover:text-white">Réalisations</a></li>
            <li><a href="#faq" className="text-white/80 hover:text-white">FAQ</a></li>
            <li><a href="#contact" className="text-white/80 hover:text-white">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="font-mono-label text-white/55">Mentions</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link to="/mentions-legales" className="text-white/80 hover:text-white">Mentions légales</Link></li>
            <li><Link to="/politique-confidentialite" className="text-white/80 hover:text-white">Confidentialité</Link></li>
            <li><Link to="/cookies" className="text-white/80 hover:text-white">Cookies</Link></li>
            <li><Link to="/cgv" className="text-white/80 hover:text-white">CGV</Link></li>
            <li><Link to="/cgu" className="text-white/80 hover:text-white">CGU</Link></li>
            <li><Link to="/admin" className="text-white/45 hover:text-white text-xs">Espace admin</Link></li>
          </ul>
        </div>
      </div>

      <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <p className="text-xs text-white/55">© {new Date().getFullYear()} WebUP — Tous droits réservés.</p>
        <p className="text-xs text-white/55">Création de sites web — Marssac-sur-Tarn, Albi, Gaillac, Castres, Carmaux — Occitanie.</p>
      </div>
    </div>
  </footer>
);
